import { Component, computed, input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnTypeCssClassPipe } from '../../pipes/column-type-css-class.pipe';
import { TableBodyCellComponent } from '../table-body-cell/table-body-cell.component';
import { ColumnKeyCssClassPipe } from '../../pipes/column-key-css-class.pipe';
import { TableItemActionsComponent } from '../table-item-actions/table-item-actions.component';
import { TableDataKey } from '../../types/table-data-key';
import { TableColumn } from '../../models/table-column';
import { Nillable, valueOrDefault } from '@web/utils';
import { TableItemAction } from '../../models/table-item-action';
import { TableCustomCellTemplateContext } from '../../models/table-custom-cell-template-context';
import { TableModule } from 'primeng/table';
import { Icon } from '../../../icon/enums/icon';
import { IconComponent } from '../../../icon/components/icon/icon.component';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[app-table-body-row]',
  imports: [
    CommonModule,
    TableBodyCellComponent,
    ColumnTypeCssClassPipe,
    ColumnKeyCssClassPipe,
    TableItemActionsComponent,
    ColumnTypeCssClassPipe,
    ColumnKeyCssClassPipe,
    TableBodyCellComponent,
    TableModule,
    IconComponent,
    TooltipModule,
  ],
  templateUrl: './table-body-row.component.html',
  styleUrls: ['./table-body-row.component.scss'],
})
export class TableBodyRowComponent<Item, Filter, ItemAction> {
  public readonly first = input.required<number>();
  public readonly index = input.required<number>();
  public readonly model = input.required<Item>();
  public readonly dataKey = input.required<TableDataKey<Item>>();
  public readonly reordering = input.required<boolean>();
  public readonly columns = input.required<TableColumn<Item, Filter>[]>();
  public readonly bodyRowSelectionDisabled = input.required<boolean>();
  public readonly appendLabels = input.required<boolean>();
  /* prettier-ignore */
  public readonly itemActions = input.required<Nillable<TableItemAction<Item, ItemAction>[]>>();
  /* prettier-ignore */
  public readonly customCellTemplateRef = input<Nillable<TemplateRef<TableCustomCellTemplateContext<Item, Filter>>>>();

  protected readonly order = computed(() => this.first() + this.index() + 1);

  protected readonly Icon = Icon;
  protected readonly valueOrDefault = valueOrDefault;
}
